import {Box, Divider, useTheme} from "@mui/material"
import React from "react"
import ContainerStyledTableRow from "./ContainerStyledTable/ContainerStyledTableRow"
import Content from "../../components/Content"

export const containerStyledTablePrototype = [
    "gridconfiguration",
    {
        key: "dividerPosition",
        type: "SELECT",
        label: "Divider Position",
        options: [
            {label: "Nach Header (y=0/y≥1)", value: "afterHeader"},
            {label: "Nach erster Datenzeile (y=1/y>1)", value: "afterFirstRow"},
            {label: "Nicht anzeigen", value: "dontShowDivider"},
        ],
        size: 6,
    },
    {
        key: "showVerticalBorders",
        type: "YESNO",
        label: "Vertikale Borders anzeigen",
        size: 6,
    },
]

const ARRAYOFFSET = 1

const ContainerStyledTable = ({container, value}) => {
    const theme = useTheme()
    const headerBg = theme.STYLEDTABLE?.headerBackground ?? "#f8f9fa"
    const dividerColor = theme.STYLEDTABLE?.dividerColor ?? "#3958D5"
    const borderColor = theme.STYLEDTABLE?.borderColor ?? "#dee2e6"

    const rows = value ?? []
    const {dividerPosition, showVerticalBorders, columncount} = container

    const headerWidgets = container.children?.filter((entry) => entry.y === 0)
    const contentWidgets = container.children?.filter(
        (entry) => entry.y === 1,
    )
    const additionalWidgets = container.children?.filter(
        (entry) => entry.y > 1,
    )

    const dividerAfterHeader = dividerPosition !== "afterFirstRow"
    const dividerGridRow = dividerAfterHeader ? 2 : (rows?.length >= 1 ? 3 : 2)

    return (
        <Box
            sx={{
                display: "grid",
                gridTemplateColumns: `repeat(${columncount}, 1fr)`,
                alignItems: "center",
            }}>
            {headerWidgets?.map((widget) => {
                const isLastColumn = widget.x + widget.w >= columncount
                return (
                    <Box
                        key={widget.id}
                        height="100%"
                        sx={{
                            gridColumn: widget.x + 1 + " /span " + widget.w,
                            gridRow: widget.y + 1 + " /span " + widget.h,
                            bgcolor: headerBg,
                            padding: "8px 12px",
                            borderBottom: `1px solid ${borderColor}`,
                            borderRight: showVerticalBorders && !isLastColumn
                                ? `1px solid ${borderColor}`
                                : "none",
                        }}>
                        <Content child={widget} />
                    </Box>
                )
            })}
            {rows?.length ? (
                rows.map((row, key) =>
                    contentWidgets?.map((widget) => (
                        <ContainerStyledTableRow
                            key={widget.id + key}
                            row={row}
                            widget={widget}
                            rowCount={key}
                            showVerticalBorders={showVerticalBorders}
                            borderColor={borderColor}
                            columncount={columncount}
                        />
                    )),
                )
            ) : (
                <Box
                    padding={2}
                    sx={{
                        gridColumn: 1 + " /span " + columncount,
                        gridRow: 2,
                    }}>
                    Keine Einträge
                </Box>
            )}
           {dividerPosition !== "dontShowDivider" && <Divider
                sx={{
                    gridColumn: "1 / -1",
                    gridRow: dividerGridRow,
                    height: "2px",
                    bgcolor: dividerColor,
                }}
            />}
            {additionalWidgets?.map((widget) => {
                const isLastColumn = widget.x + widget.w >= columncount
                return (
                    <Box
                        key={widget.id}
                        sx={{
                            gridColumn:
                                widget.x + ARRAYOFFSET + " /span " + widget.w,
                            gridRow:
                                widget.y +
                                ARRAYOFFSET +
                                (rows?.length ? rows?.length : 1) +
                                " /span " +
                                widget.h,
                            padding: "8px 12px",
                            borderBottom: `1px solid ${borderColor}`,
                            borderRight: showVerticalBorders && !isLastColumn
                                ? `1px solid ${borderColor}`
                                : "none",
                        }}>
                        <Content key={widget.i} child={widget} />
                    </Box>
                )
            })}
        </Box>
    )
}

export default ContainerStyledTable
